import ListObjectModel from './ListObjectModel';

export default new ListObjectModel();